'use client';
import { motion, AnimatePresence } from 'framer-motion';
import React, { FC, useState } from 'react';

import './styles.scss';
import { HistoryType } from '@/api/services/GameService/types';
import { useTranslation } from '@/hooks/useTranslations';

interface OurHistoryProps {
  data: HistoryType[];
}

const OurHistory: FC<OurHistoryProps> = ({ data }) => {
  const { t } = useTranslation();
  const [historyData, sretHistoryData] = useState(data[0]);

  const [activeIndex, setActiveIndex] = useState(0);

  const onSelect = (history: HistoryType) => {
    sretHistoryData(history);
  };

  return (
    <div className="ourHistoryWrapper" id="history">
      <div className="bigContent">
        <div className="ourHistoryContent">
          <h2 className="ourHistoryHeader">{t('Aboutus-OurHistory-Title')}</h2>
          <div className="ourHistoryLine">
            <div className="ourHistoryLineWrp">
              <div className="ourHistoryYearBlock">
                {data.map((item, index) => (
                  <div
                    key={item.year}
                    onClick={() => {
                      setActiveIndex(index);
                      onSelect(item);
                    }}
                    className={`ourHistoryYear ${index === activeIndex ? 'active' : ''}`}
                  >
                    <p className="ourHistoryYearText">{item.year}</p>
                    <div className="ourHistoryYearDot" />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="ourHistoryDataBlock">
            <div className="ourHistoryDesc">
              <AnimatePresence mode="wait">
                <motion.div
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -50 }}
                  transition={{ duration: 0.5 }}
                >
                  <p className="ourHistoryDescHeader">{historyData?.title}</p>
                  <div
                    className="ourHistoryDescText"
                    dangerouslySetInnerHTML={{
                      __html: historyData?.description,
                    }}
                  />
                </motion.div>
              </AnimatePresence>
            </div>
            <div className="ourHistoryDescYear">
              <AnimatePresence mode="wait">
                {data.map((item, index) => {
                  const active = activeIndex;
                  const previous = index === activeIndex - 1;
                  const next = index === activeIndex + 1;
                  const className =
                    index === active ? 'active' : previous ? 'previous' : next ? 'next' : '';

                  return (
                    index === activeIndex && (
                      <motion.h2
                        key={item.year}
                        onClick={() => onSelect(item)}
                        className={`ourHistoryDescYearText ${className}`}
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -50 }}
                        transition={{ duration: 0.5 }}
                      >
                        {item.year}
                      </motion.h2>
                    )
                  );
                })}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurHistory;
